module.exports = __webpack_public_path__ + "static/media/change-password-inactive-vector.9989d99f.svg";